import moment from "moment";

export const handleFormatdateFromEpochTime = (
    epochTime: number,
    format?: string
) => {
    return moment.unix(epochTime).format(format || "MM/DD/YYYY");
};
